export const DEALER_RETURN_POLICY_ESPOT_NAME = 'DEALER_RETURN_POLICY_espot';
export const RETURN_POLICY_LINK_ESPOT_NAME = 'RETURN_POLICY_espot';
export const eSpotNames = `${DEALER_RETURN_POLICY_ESPOT_NAME},${RETURN_POLICY_LINK_ESPOT_NAME}`;
export const PCC_RETURN_POLICY_MESSAGE_TYPE = 'PCC_RETURN_POLICY_MESSAGE';
export const PCC_NON_RETURNABLE_PART_NOTE = 'NON_RETURNABLE_PART_NOTE';
